export default "__VITE_ASSET__CRIi0nUi__"